import { Route } from "found";
import DocumentTitle from "react-document-title";

import { CustomerLogoQuery } from "../authentication/CustomerLogoQuery";
import LoginPage from "../authentication/LoginPage";

import HomeContent from "./HomeContent";
import { HomeContentQuery } from "./HomeContentQuery";

const HomeContentWrapper = props => (
  <DocumentTitle title="PolicyStat Home">
    <HomeContent {...props} />
  </DocumentTitle>
);

const LoginPageWrapper = props => (
  <DocumentTitle title="PolicyStat">
    <LoginPage {...props} />
  </DocumentTitle>
);

const routes = (
  <Route
    getComponent={({ context }) => {
      if (context.viewer) {
        return HomeContentWrapper;
      } else {
        return LoginPageWrapper;
      }
    }}
    getQuery={({ context }) => {
      if (context.viewer) {
        return HomeContentQuery;
      } else {
        return CustomerLogoQuery;
      }
    }}
    data={{ routeName: "home" }}
  />
);

export default routes;
